<template>
  <div class="custom-surveys-wrapper">
    <div class="top">
      <div class="top-bar"></div>
    </div>
    <div class="body">
      <Sidebar :activeTab="activeTab" />
      <div class="content">
        <div class="background">
          <PageLayout class="custom-surveys-create-page" :hasFullHeight="true">
            <template slot="header">
              <div class="header-wrap mt-3">
                <h1>{{ labels.title }}</h1>
                <MainNavbar :activeTab="activeTab" @changeTab="changeTab" />
                <LanguageNavbar
                  v-if="activeTab !== 0"
                  class="mt-3"
                  :languages="languages"
                  :availableLanguages="availableLanguages"
                  :selectedLanguage="selectedLanguage"
                  @selectLanguage="selectLanguage"
                />
              </div>
            </template>
            <template slot="main">
              <div class="custom-surveys-create-container">
                <ConfigurationsTab
                  v-if="activeTab === 0"
                  :period="period"
                  :languages="languages"
                  :availableLanguages="availableLanguages"
                  :questionsDistribution="questionsDistribution"
                  :questionsQuantity="questionsQuantity"
                  :enableFeedbacks="enableFeedbacks"
                  :mandatoryQuestions="mandatoryQuestions"
                  :sendToCompany="surveyPublic.sendToCompany"
                  :groupsWithHierarchy="surveyPublic.groupsWithHierarchy"
                  :groupsOnly="surveyPublic.groupsOnly"
                  :users="surveyPublic.users"
                  :managersPermission="surveyAccess.managersPermission"
                  :surveyAccessUsers="surveyAccess.users"
                  :creator="creator"
                  @changeProperty="changeProperty"
                  @editSurveyPublic="editSurveyPublic"
                  @editSurveyAccessPermission="editSurveyAccessPermission"
                  @changeSurveyPublicProperty="changeSurveyPublicProperty"
                  @changeSurveyAccessProperty="changeSurveyAccessProperty"
                  @removeElementFromListOfObject="removeElementFromListOfObject"
                />
                <SurveyInformationsTab
                  v-if="activeTab === 1"
                  :languages="languages"
                  :availableLanguages="availableLanguages"
                  :selectedLanguage="selectedLanguage"
                  :questions="questions"
                  :title="title"
                  :description="description"
                  :categories="categories"
                  @changeLanguageProperty="changeLanguageProperty"
                  @addQuestion="addQuestion"
                  @removeQuestion="removeQuestion"
                  @addCategory="addCategory"
                  @removeCategory="removeCategory"
                  @changeLanguageListProperty="changeLanguageListProperty"
                  @changeListProperty="changeListProperty"
                  @moveQuestion="moveQuestion"
                  @moveCategory="moveCategory"
                  @createCategoryOfQuestion="createCategoryOfQuestion"
                  @addAnswer="addAnswer"
                  @removeAnswer="removeAnswer"
                  @togglePopoverAddCategory="togglePopoverAddCategory"
                  @changeLanguageListOfListProperty="
                    changeLanguageListOfListProperty
                  "
                  @changeListOfListProperty="changeListOfListProperty"
                  @removeQuestionFromCategory="removeQuestionFromCategory"
                  @moveUpQuestionAnswer="moveUpQuestionAnswer"
                  @moveDownQuestionAnswer="moveDownQuestionAnswer"
                />
                <SummaryTab
                  v-if="activeTab === 2"
                  :languages="languages"
                  :availableLanguages="availableLanguages"
                  :selectedLanguage="selectedLanguage"
                  :title="title"
                  :description="description"
                  :period="period"
                  :questionsDistribution="questionsDistribution"
                  :questionsQuantity="questionsQuantity"
                  :enableFeedbacks="enableFeedbacks"
                  :mandatoryQuestions="mandatoryQuestions"
                  :questions="questions"
                  :categories="categories"
                  :sendToCompany="surveyPublic.sendToCompany"
                  :groupsWithHierarchy="surveyPublic.groupsWithHierarchy"
                  :groupsOnly="surveyPublic.groupsOnly"
                  :users="surveyPublic.users"
                  :managersPermission="surveyAccess.managersPermission"
                  :surveyAccessUsers="surveyAccess.users"
                  :creator="creator"
                />
                <Footer
                  :activeTab="activeTab"
                  :isLoading="isLoading"
                  @changeTab="changeTab"
                  @saveDraftAndExit="saveDraft(true)"
                  @scheduleSurvey="scheduleSurvey"
                  @sendSurvey="sendSurvey"
                  @exit="exit"
                />
                <SurveyLaunchModal
                  ref="survey-launch-modal"
                  :sendSurveyNow="sendSurveyNow"
                  @launchSurvey="launchSurvey"
                />
                <SurveyPublicModal
                  ref="survey-public-modal"
                  :sendToCompany="surveyPublic.sendToCompany"
                  :groupsWithHierarchy="surveyPublic.groupsWithHierarchy"
                  :groupsWithHierarchyOptions="
                    surveyPublic.groupsWithHierarchyOptions
                  "
                  :groupsOnly="surveyPublic.groupsOnly"
                  :groupsOnlyOptions="surveyPublic.groupsOnlyOptions"
                  :users="surveyPublic.users"
                  :usersOptions="surveyPublic.usersOptions"
                  @changeSurveyPublicProperty="changeSurveyPublicProperty"
                  @searchForUsers="searchForUsers"
                  @searchForGroups="searchForGroups"
                />
                <SurveyAccessPermissionModal
                  ref="survey-access-permission-modal"
                  :managersPermission="surveyAccess.managersPermission"
                  :users="surveyAccess.users"
                  :usersOptions="surveyAccess.usersOptions"
                  @changeSurveyAccessProperty="changeSurveyAccessProperty"
                  @searchForManagers="searchForManagers"
                />
              </div>
              <SurveyFormErrorsModal
                ref="survey-form-errors-modal"
                :errors="this.activeTabErrors"
              />
            </template>
          </PageLayout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getUser } from '@/service/user'
import PageLayout from '@/components/Home/PageLayout.vue'
import MainNavbar from '@/components/CustomSurveys/Create/Navbars/MainNavbar.vue'
import LanguageNavbar from '@/components/CustomSurveys/Create/Navbars/LanguageNavbar.vue'
import Footer from '@/components/CustomSurveys/Create/Layout/Footer.vue'
import Sidebar from '@/components/CustomSurveys/Create/Layout/Sidebar.vue'
import ConfigurationsTab from '@/components/CustomSurveys/Create/Tabs/ConfigurationsTab.vue'
import SurveyInformationsTab from '@/components/CustomSurveys/Create/Tabs/SurveyInformationsTab.vue'
import SummaryTab from '@/components/CustomSurveys/Create/Tabs/SummaryTab.vue'
import SurveyLaunchModal from '@/components/CustomSurveys/Create/Modals/SurveyLaunchModal.vue'
import SurveyPublicModal from '@/components/CustomSurveys/Create/Modals/SurveyPublicModal.vue'
import SurveyAccessPermissionModal from '@/components/CustomSurveys/Create/Modals/SurveyAccessPermissionModal.vue'
import SurveyFormErrorsModal from '@/components/CustomSurveys/Create/Modals/SurveyFormErrorsModal.vue'

export default {
  components: {
    PageLayout,
    MainNavbar,
    LanguageNavbar,
    Footer,
    Sidebar,
    ConfigurationsTab,
    SurveyInformationsTab,
    SummaryTab,
    SurveyLaunchModal,
    SurveyPublicModal,
    SurveyAccessPermissionModal,
    SurveyFormErrorsModal,
  },
  data() {
    return {
      activeTab: 0,
      selectedLanguage: 0,
      isLoading: false,
      sendSurveyNow: false,
      activeTabErrors: [],
    }
  },
  computed: {
    ...mapGetters({
      languages: 'languages',
      languageSelected: 'languageSelected',
      resources: 'resources',
      period: 'customSurveys/period',
      mandatoryQuestions: 'customSurveys/mandatoryQuestions',
      enableFeedbacks: 'customSurveys/enableFeedbacks',
      questionsDistribution: 'customSurveys/questionsDistribution',
      questionsQuantity: 'customSurveys/questionsQuantity',
      availableLanguages: 'customSurveys/availableLanguages',
      questions: 'customSurveys/questions',
      title: 'customSurveys/title',
      description: 'customSurveys/description',
      categories: 'customSurveys/categories',
      id: 'customSurveys/id',
      surveyPublic: 'customSurveys/surveyPublic',
      surveyAccess: 'customSurveys/surveyAccess',
    }),
    labels() {
      return {
        ...this.resources.component.customSurveys.create,
        ...this.resources.page.customSurveys.create,
      }
    },
    creator() {
      const me = getUser()
      return `${me.profile.firstname} ${me.profile.lastname}`
    },
  },
  async mounted() {
    this.$store.dispatch('customSurveys/resetState', this.languageSelected)

    if (this.$route.params.id) {
      this.isLoading = true
      this.$store.dispatch(
        'customSurveys/loadCustomSurvey',
        this.$route.params.id
      )
      this.isLoading = false
    }

    this.$root.$emit('setPageTitle', {
      context: this,
      path: 'custom-surveys/create',
    })
  },
  methods: {
    removeElementFromListOfObject({ object, property, value }) {
      this.$store.dispatch('customSurveys/removeElementFromListOfObject', {
        object,
        property,
        value,
      })
    },
    removeQuestionFromCategory({ categoryId, questionId }) {
      this.$store.dispatch('customSurveys/removeQuestionFromCategory', {
        categoryId,
        questionId,
      })
    },
    searchForGroups(value, property) {
      this.$store.dispatch('customSurveys/searchForGroups', { value, property })
    },
    searchForUsers(value) {
      this.$store.dispatch('customSurveys/searchForUsers', { value })
    },
    searchForManagers(value) {
      this.$store.dispatch('customSurveys/searchForUsers', {
        value,
        role: 'manager',
      })
    },
    exit() {
      this.$router.push({
        name: 'custom-surveys',
        params: { status: 'draft' },
      })
    },
    changeTab(tab) {
      // going back
      if (this.activeTab > tab) {
        this.activeTab = tab
        return
      }

      // going forward
      if (this.activeTab === 0 && [1, 2].includes(tab)) {
        const errors = this.getConfigurationsTabErrors()
        if (errors.length > 0) {
          this.activeTabErrors = errors
          return this.$refs['survey-form-errors-modal'].show()
        }
      } else if (this.activeTab === 1 && tab === 2) {
        const errors = this.getSurveyInformationsTabErrors()
        if (errors.length > 0) {
          this.activeTabErrors = errors
          return this.$refs['survey-form-errors-modal'].show()
        }
      }
      // no errors
      this.activeTabErrors = []

      // save draft going to summary
      if ([0, 1].includes(this.activeTab) && tab === 2) {
        this.saveDraft(false)
      }

      this.activeTab = tab
    },
    selectLanguage(language) {
      this.selectedLanguage = language
    },
    changeProperty({ property, value }) {
      this.$store.dispatch('customSurveys/changeProperty', { property, value })
    },
    changeSurveyPublicProperty({ property, value }) {
      this.$store.dispatch('customSurveys/changeSurveyPublicProperty', {
        property,
        value,
      })
    },
    changeSurveyAccessProperty({ property, value }) {
      this.$store.dispatch('customSurveys/changeSurveyAccessProperty', {
        property,
        value,
      })
    },
    changeLanguageProperty({ property, language, value }) {
      this.$store.dispatch('customSurveys/changeLanguageProperty', {
        property,
        language,
        value,
      })
    },
    addQuestion() {
      this.$store.dispatch('customSurveys/addQuestion')
    },
    removeQuestion(idx) {
      this.$store.dispatch('customSurveys/removeQuestion', { idx })
    },
    changeLanguageListProperty({
      value,
      collection,
      index,
      property,
      language,
    }) {
      this.$store.dispatch('customSurveys/changeLanguageListProperty', {
        value,
        collection,
        index,
        property,
        language,
      })
    },
    changeListProperty({ value, collection, index, property }) {
      this.$store.dispatch('customSurveys/changeListProperty', {
        value,
        collection,
        index,
        property,
      })
    },
    addCategory() {
      this.$store.dispatch('customSurveys/addCategory')
    },
    removeCategory(idx) {
      this.$store.dispatch('customSurveys/removeCategory', { idx })
    },
    moveQuestion({ from, to }) {
      this.$store.dispatch('customSurveys/moveQuestion', { from, to })
    },
    moveCategory({ from, to }) {
      this.$store.dispatch('customSurveys/moveCategory', { from, to })
    },
    createCategoryOfQuestion({ questionIndex, categoryLabel }) {
      this.$store.dispatch('customSurveys/createCategoryOfQuestion', {
        questionIndex,
        categoryLabel,
        language: this.availableLanguages[this.selectedLanguage],
      })
    },
    launchSurvey(launchConfiguration) {
      this.saveDraft(true, launchConfiguration)
    },
    saveDraft(exit, launchConfiguration = {}) {
      this.isLoading = true

      const onSaveSuccess = () => {
        if (exit) {
          const status =
            Object.keys(launchConfiguration).length === 0
              ? 'draft'
              : launchConfiguration.sendSurveyNow
              ? 'active'
              : 'scheduled'
          this.$router.push({
            name: 'custom-surveys',
            params: { status },
          })
        }
      }
      const onSaveError = error => {
        // console.log(error)
        alert('error' + error)
      }

      const {
        id,
        period,
        questionsDistribution,
        questionsQuantity,
        mandatoryQuestions,
        enableFeedbacks,
        availableLanguages,
        title,
        description,
        categories,
        questions,
        surveyPublic,
        surveyAccess,
      } = this

      const status =
        Object.keys(launchConfiguration).length === 0 // empty object
          ? 'draft'
          : launchConfiguration.sendSurveyNow
          ? 'active'
          : 'scheduled'

      const draft = {
        id,
        period,
        questionsDistribution,
        questionsQuantity,
        mandatoryQuestions,
        enableFeedbacks,
        availableLanguages,
        launchConfiguration,
        status,
        title,
        description,
        categories,
        questions: questions.map(
          ({ question_id, type, category, enableScore, text, answers }) => ({
            question_id,
            type,
            category,
            enableScore,
            text,
            answers,
          })
        ),
        surveyPublic: {
          sendToCompany: surveyPublic.sendToCompany,
          groupsWithHierarchy: surveyPublic.groupsWithHierarchy,
          groupsOnly: surveyPublic.groupsOnly,
          users: surveyPublic.users,
        },
        surveyAccess: {
          managersPermission: surveyAccess.managersPermission,
          users: surveyAccess.users,
        },
      }

      this.$store
        .dispatch('customSurveys/saveDraft', draft)
        .then(onSaveSuccess)
        .catch(onSaveError)
        .finally(() => {
          this.isLoading = false
        })
    },
    scheduleSurvey() {
      this.sendSurveyNow = false
      const modal = this.$refs['survey-launch-modal']
      modal.clearState()
      modal.show()
    },
    sendSurvey() {
      this.sendSurveyNow = true
      const modal = this.$refs['survey-launch-modal']
      modal.clearState()
      modal.show()
    },
    editSurveyPublic() {
      this.$refs['survey-public-modal'].show()
    },
    editSurveyAccessPermission() {
      this.$refs['survey-access-permission-modal'].show()
    },
    addAnswer({ questionIndex }) {
      this.$store.dispatch('customSurveys/addAnswer', { questionIndex })
    },
    removeAnswer({ answerId, questionIndex }) {
      this.$store.dispatch('customSurveys/removeAnswer', {
        answerId,
        questionIndex,
      })
    },
    togglePopoverAddCategory({ index, value }) {
      this.$store.dispatch('customSurveys/togglePopoverAddCategory', {
        index,
        value,
      })
    },
    changeLanguageListOfListProperty({
      value,
      collection,
      index,
      listCollection,
      listIndex,
      property,
      language,
    }) {
      this.$store.dispatch('customSurveys/changeLanguageListOfListProperty', {
        value,
        collection,
        index,
        listCollection,
        listIndex,
        property,
        language,
      })
    },
    changeListOfListProperty({
      value,
      collection,
      index,
      listCollection,
      listIndex,
      property,
    }) {
      this.$store.dispatch('customSurveys/changeListOfListProperty', {
        value,
        collection,
        index,
        listCollection,
        listIndex,
        property,
      })
    },
    moveUpQuestionAnswer({ qIdx, index }) {
      this.$store.dispatch('customSurveys/moveUpQuestionAnswer', {
        qIdx,
        index,
      })
    },
    moveDownQuestionAnswer({ qIdx, index }) {
      this.$store.dispatch('customSurveys/moveDownQuestionAnswer', {
        qIdx,
        index,
      })
    },
    getConfigurationsTabErrors() {
      const errors = []
      // check survey period
      if (this.period === '') {
        errors.push({
          field: this.labels.tabs.period.label,
          message: this.labels.tabs.period.select,
        })
      }
      // check survey available languages
      if (this.availableLanguages.length === 0) {
        errors.push({
          field: this.labels.tabs.languages.label,
          message: this.labels.tabs.languages.select,
        })
      }
      // check survey questions distribution
      if (this.questionsDistribution === '') {
        errors.push({
          field: this.labels.tabs.questionsDistribution.label,
          message: this.labels.tabs.questionsDistribution.select,
        })
      }
      // check survey questions quantity
      if (this.period !== 'single-shot' && this.questionsQuantity === 0) {
        errors.push({
          field: this.labels.tabs.questionsQuantity.label,
          message: this.labels.tabs.questionsQuantity.select,
        })
      }
      // check survey public
      if (
        !this.surveyPublic.sendToCompany &&
        this.surveyPublic.groupsWithHierarchy.length +
          this.surveyPublic.groupsOnly.length +
          this.surveyPublic.users.length ===
          0
      ) {
        errors.push({
          field: this.labels.tabs.public.label,
          message: this.labels.tabs.public.select,
        })
      }
      return errors
    },
    getSurveyInformationsTabErrors() {
      const errors = []
      // check survey questions quantity
      if (this.questions.length === 0) {
        errors.push({
          field: this.labels.tabs.questions,
          message: this.labels.questions.select,
        })
      } else {
        this.questions.forEach((question, index) => {
          if (
            question.type !== 'feedback' &&
            [null, undefined].includes(question.enableScore)
          ) {
            errors.push({
              field: `${index + 1}° ${this.labels.questions.question}`,
              message: `${this.labels.questions.score.title}`,
            })
          }
          if (
            ['select', 'multi-select'].includes(question.type) &&
            (!question.answers || question.answers.length === 0)
          ) {
            errors.push({
              field: `${index + 1}° ${this.labels.questions.question}`,
              message: `${this.labels.questions.answers.notFound}`,
            })
          }
        })
      }

      // check translations
      this.availableLanguages.forEach((language, languageIndex) => {
        const { idiom } = this.languages.find(l => l.code === language)
        // check title
        if ([null, undefined, ''].includes(this.title[language])) {
          errors.push({
            field: this.labels.tabs.surveyTitle.label,
            message: `${this.labels.tabs.surveyTitle.placeholder} (${idiom})`,
          })
        }
        // check questions
        if (this.questions.length > 0) {
          this.questions.forEach((question, index) => {
            if ([null, undefined, ''].includes(question.text[language])) {
              errors.push({
                field: `${this.labels.questions.text.title} ${index + 1}`,
                message: `${this.labels.questions.text.placeholder} (${idiom})`,
              })
            }
            if (
              ['select', 'multi-select'].includes(question.type) &&
              question.answers &&
              question.answers.length > 0
            ) {
              question.answers.forEach((answer, answerIndex) => {
                if (
                  languageIndex === 0 &&
                  question.enableScore &&
                  [null, undefined, ''].includes(answer.classification)
                ) {
                  errors.push({
                    field: `${index + 1}° ${this.labels.questions.question}`,
                    message: `${
                      this.labels.questions.answers.type.missingTitle
                    } ${answerIndex + 1}° ${
                      this.labels.questions.answers.singleTitle
                    }`,
                  })
                }
                if ([null, undefined, ''].includes(answer.text[language])) {
                  errors.push({
                    field: `${index + 1}° ${this.labels.questions.question}`,
                    message: `${answerIndex + 1}° ${
                      this.labels.questions.answers.singleTitle
                    } (${idiom})`,
                  })
                }
              })
            }
          })
        }
        // check categories
        if (this.categories.length > 0) {
          this.categories.forEach((category, index) => {
            if ([null, undefined, ''].includes(category.label[language])) {
              errors.push({
                field: `${this.labels.categories.name.title} ${index + 1}`,
                message: `${this.labels.categories.name.placeholder} (${idiom})`,
              })
            }
          })
        }
      })
      return errors
    },
  },
}
</script>

<style lang="scss">
@import '~@/styles/custom/colors';

.custom-surveys-wrapper {
  .card {
    box-shadow: none;
    border-radius: 10px !important;

    .card-header {
      border-top-left-radius: 10px !important;
      border-top-right-radius: 10px !important;
    }

    .v-select .vs__dropdown-menu,
    .v-select .vs__dropdown-toggle .vs__selected {
      border-radius: 10px !important;
    }

    .v-select .vs__dropdown-toggle,
    .custom-survey-form-input {
      border-radius: 10px !important;
      background-color: map-get($theme-colors, 'white') !important;
      border-color: var(--gray07) !important;
    }

    .readonly-input .vs__dropdown-toggle {
      border-color: map-get($theme-colors, 'white') !important;
    }
  }
}
</style>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';

.custom-surveys-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  width: 100%;

  .top {
    width: 100%;
    z-index: 0;

    .top-bar {
      background: linear-gradient(220deg, #bc161c, #ff000a);
      height: 2px;
    }
  }

  .body {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .content {
      padding: 0;
      position: relative;
      z-index: 0;
      min-width: 0px;
      flex: 1 1 auto;
      overflow: auto;
      flex-grow: 1;
      --webkit-flex-grow: 1;
    }
  }
}

.background {
  display: flex;
  background-color: map-get($theme-colors, 'white02');
  width: 100%;
  height: 100% !important;
  height: -moz-fit-content;
  height: fit-content;
  justify-content: center;

  .custom-surveys-create-page {
    .header-wrap {
      width: 100%;
      display: flex;
      flex-direction: column;

      h1 {
        text-align: center;
        color: map-get($theme-colors, 'secondary');
        font-size: 1.7rem;
      }
    }

    .custom-surveys-create-container {
      height: calc(100% - 90px);
      display: flex;
      width: 100%;
      flex-direction: column;

      .content {
        min-height: 100%;
        width: 100%;
        height: 100%;
        overflow-y: auto;

        /deep/ .form-group {
          label:not(.custom-input-label),
          legend {
            color: map-get($theme-colors, 'primary') !important;
            position: absolute;
            top: -18px;
            margin-left: 20px;
            font-size: 12px;
          }
          small {
            font-size: 12px;
            margin-left: 15px;
          }
        }
      }
    }
  }
}
</style>
